<template>
  <!-- <div class="lang-dropdown">
    <select v-model="lang">
      <option
        v-for="(lang, i) in languageArray"
        :key="`lang${i}`"
        :value="lang"
      >
        {{ lang }}
      </option>
    </select>
  </div> -->
  <!--language modal -->
  <div
    class="modal fade show"
    id="chnagelangModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="change-lang-modal">
            <h3>{{$t("language.title")}}</h3>
            <p>
              {{$t("language.displaytext")}}
            </p>
            <div class="language-list lang-dropdown">
              <ul>
                <li
                  v-for="(lang, i) in languageArray"
                  :key="`lang${i}`"
                  :value="lang"
                  :style="$store.state.locale === languageArray[i] ?'border:2px solid #007bff; font-weight:bold': 'border:1px solid #000' "
                >
                <a href="javascript:void(0)" @click.prevent="changelanguage(languageArray[i])">
                {{ lang }}
                </a>
                </li>
              </ul>
            </div>
            <a href="" style="display:none" class="lnksave">Save</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--language modal ends -->
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
import { languages } from "@/plugins/i18n";
export default {
  name: "langDropdown",
  data() {
    return {
      languageArray: languages,
    };
  },
  methods:{
    changelanguage(newVal)
    {
      this.$store.dispatch("changeLocale", newVal);
      $('#chnagelangModalCenter').modal('toggle');
    }
  },
  computed: {
    lang: {
      get: function () {
        return this.$store.state.locale;
      },
      set: function (newVal) {
        debugger
        this.$store.dispatch("changeLocale", newVal);
      },
    },
  },
};
</script>

<style>
	.change-lang-modal {width: 100%; text-align: center;}
	.change-lang-modal h3 {font-size: 20px;font-weight: 600;color: #737373;}
	.change-lang-modal p {font-size: 14px; font-weight: 400; color: #585858;margin-bottom: 0; margin-top: 15px;}
	.language-list {margin-top: 20px; height: 330px; overflow-y: auto; padding: 10px 15px; background: #fbfbfb;}
	.language-list ul {margin: 0; padding: 0;}
	.language-list ul li {list-style: none; display: block; border: 1px solid #737373; padding: 0; margin-bottom: 10px; border-radius: 4px; font-size: 14px; font-weight: 400; color: #6b6b6b;cursor: pointer;}
	.language-list ul li.selected-lang{color: #155295; border-color: #155295; font-weight: 600;}
  .language-list ul li a {display: block; padding:10px;}
	.change-lang-modal a.lnksave {display: inline-block; width: 100%; padding: 8px 0; background: #155295; color: #fff; margin-top: 30px; border-radius: 4px; font-weight: 600;    font-size: 14px; text-transform: uppercase;}
	</style>